// Mock data for Zaya Abaya & Hijab Shop

export const collections = [
  {
    id: 1,
    name: "Classic Black Collection",
    description: "Timeless elegance in black abayas",
    image: "https://images.unsplash.com/photo-1767647986631-efdd7b1e6e18?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwxfHxlbGVnYW50JTIwYWJheWF8ZW58MHx8fHwxNzcwNzMwNzM3fDA&ixlib=rb-4.1.0&q=85",
    items: 12
  },
  {
    id: 2,
    name: "Luxury Evening Collection",
    description: "Sophisticated designs for special occasions",
    image: "https://images.unsplash.com/photo-1767469697194-ac997d70b1ee?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwyfHxlbGVnYW50JTIwYWJheWF8ZW58MHx8fHwxNzcwNzMwNzM3fDA&ixlib=rb-4.1.0&q=85",
    items: 8
  },
  {
    id: 3,
    name: "Embroidered Elegance",
    description: "Intricate embroidery with modern flair",
    image: "https://images.unsplash.com/photo-1760083545495-b297b1690672?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwzfHxlbGVnYW50JTIwYWJheWF8ZW58MHx8fHwxNzcwNzMwNzM3fDA&ixlib=rb-4.1.0&q=85",
    items: 10
  },
  {
    id: 4,
    name: "Contemporary Styles",
    description: "Modern cuts with traditional modesty",
    image: "https://images.unsplash.com/photo-1762376128087-bc29c6df08c0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHw0fHxlbGVnYW50JTIwYWJheWF8ZW58MHx8fHwxNzcwNzMwNzM3fDA&ixlib=rb-4.1.0&q=85",
    items: 15
  },
  {
    id: 5,
    name: "Premium Hijab Collection",
    description: "Luxurious fabrics and versatile styles",
    image: "https://images.unsplash.com/photo-1627359212239-3d82a215af75?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjV8MHwxfHNlYXJjaHwzfHxtb2Rlc3QlMjBmYXNoaW9ufGVufDB8fHx8MTc3MDYyNjc3NXww&ixlib=rb-4.1.0&q=85",
    items: 20
  },
  {
    id: 6,
    name: "Everyday Essentials",
    description: "Comfortable and stylish daily wear",
    image: "https://images.unsplash.com/photo-1626386699888-b8865823b279?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjV8MHwxfHNlYXJjaHwxfHxtb2Rlc3QlMjBmYXNoaW9ufGVufDB8fHx8MTc3MDYyNjc3NXww&ixlib=rb-4.1.0&q=85",
    items: 18
  }
];

export const featuredProducts = [
  {
    id: 1,
    name: "Midnight Grace Abaya",
    // price: "₹2,999",
    image: "https://images.unsplash.com/photo-1767647986631-efdd7b1e6e18?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwxfHxlbGVnYW50JTIwYWJheWF8ZW58MHx8fHwxNzcwNzMwNzM3fDA&ixlib=rb-4.1.0&q=85",
    category: "Classic",
    new: true
  },
  {
    id: 2,
    name: "Royal Evening Abaya",
    //price: "₹4,499",
    image: "https://images.unsplash.com/photo-1767469697194-ac997d70b1ee?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwyfHxlbGVnYW50JTIwYWJheWF8ZW58MHx8fHwxNzcwNzMwNzM3fDA&ixlib=rb-4.1.0&q=85",
    category: "Luxury",
    featured: true
  },
  {
    id: 3,
    name: "Pearl Embroidered Abaya",
    //price: "₹3,999",
    image: "https://images.unsplash.com/photo-1760083545495-b297b1690672?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwzfHxlbGVnYW50JTIwYWJheWF8ZW58MHx8fHwxNzcwNzMwNzM3fDA&ixlib=rb-4.1.0&q=85",
    category: "Embroidered",
    featured: true
  },
  {
    id: 4,
    name: "Modern Chic Abaya",
    //price: "₹3,499",
    image: "https://images.unsplash.com/photo-1762376128087-bc29c6df08c0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHw0fHxlbGVnYW50JTIwYWJheWF8ZW58MHx8fHwxNzcwNzMwNzM3fDA&ixlib=rb-4.1.0&q=85",
    category: "Contemporary",
    new: true
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Fatima Begum",
    rating: 5,
    text: "The quality and elegance of Zaya's abayas are unmatched. Every piece feels luxurious and special.",
    location: "Chennai, Tamil Nadu"
  },
  {
    id: 2,
    name: "Aisha Rahman",
    rating: 5,
    text: "Beautiful designs that perfectly blend modesty with modern style. My favorite abaya shop!",
    location: "Tambaram, Chennai"
  },
  {
    id: 3,
    name: "Mariam Hassan",
    rating: 5,
    text: "Exceptional service and stunning collection. The embroidery work is absolutely exquisite.",
    location: "Velachery, Chennai"
  }
];

export const shopInfo = {
  name: "Zaya",
  tagline: "Elegance • Modesty • Style",
  description: "Discover timeless elegance with Zaya's exclusive collection of abayas and hijabs. Each piece is carefully curated to celebrate modesty while embracing contemporary fashion.",
  email: "zayaabaya1417@gmail.com",
  phone: "+91 XXXXX XXXXX",
  whatsapp: "+91 XXXXX XXXXX",
  address: "Muthamil Nagar, Pammal, Chennai - 600043, Tamil Nadu, India",
  hours: "10:00 AM - 10:00 PM (Daily)",
  social: {
    instagram: "@zaya_abaya_hijab",
    facebook: "ZayaAbaya"
  }
};
